
import React from "react";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import SubscriptionPageContent from "./content";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

export default function SpitialSubscription() {
  return (
    <div className="legacy-app-shell">
      <div className="legacy-app-shell-sidebar">
        <Menu focusKey="MENU" />
      </div>
      <div className="legacy-app-shell-content">
        <SubscriptionPageContent />
      </div>
    </div>
  );
}

